export default __webpack_public_path__ + "static/notas-e9566b2f193e00bfc2434ae49129b2eb.jpg";